(function () {
  if (window.__scEnvio) { window.__scEnvio.escanear(); return; }

  /* Tarifas y zonas de cobertura (Gs.). Editar acá si cambian. */
  var TARIFAS = [
    { monto: 25000, zonas: ['Asunción', 'Lambaré', 'Fernando de la Mora', 'Loma Pytá', 'Zeballos Cué', 'Villa Elisa', 'San Lorenzo'] },
    { monto: 30000, zonas: ['Ñemby', 'San Antonio', 'Mariano Roque Alonso', 'Luque'] },
    { monto: 35000, zonas: ['Capiatá', 'Ypané'] },
    { monto: 40000, zonas: ['Limpio (solo centro)', 'Itauguá', 'Areguá', 'J. A. Saldívar', 'Guarambaré'] },
    { monto: 45000, zonas: ['Itá', 'Ypacaraí'] }
  ];
  var PUNTO_RETIRO = 'Retiro en Asunción Centro';
  var LLAVE = 'silverco-envio-zona';
  var CAMPOS = ['dir', 'barrio', 'ref'];
  var zona = '';
  var modo = 'envio';
  var datos = {};
  var totalTxt = '';
  try { zona = localStorage.getItem(LLAVE) || ''; } catch (e) {}
  try { modo = localStorage.getItem(LLAVE + '-modo') === 'retiro' ? 'retiro' : 'envio'; } catch (e) {}
  try { datos = JSON.parse(localStorage.getItem(LLAVE + '-datos') || '{}') || {}; } catch (e) {}

  var gs = function (n) { return 'Gs. ' + Math.round(n).toLocaleString('es-PY'); };
  var raices = function () { return document.querySelectorAll('[data-calc-envio]'); };
  var montoDe = function (z) {
    for (var i = 0; i < TARIFAS.length; i++) if (TARIFAS[i].zonas.indexOf(z) > -1) return TARIFAS[i].monto;
    return 0;
  };
  /* Listo para pagar: retiro presencial, o envío con ciudad elegida. */
  var hayZona = function () { return modo === 'retiro' || !!montoDe(zona); };

  /* Datos de entrega -> Supabase de Silver & Co (función entrega-web). La llave anon es pública por diseño. */
  var SUPA_URL = 'https://nituzlaboqqetopejklk.supabase.co/functions/v1/entrega-web';
  var SUPA_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5pdHV6bGFib3FxZXRvcGVqa2xrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTEzMzQzODksImV4cCI6MjEwNjkxMDM4OX0.-y45ABrnsskSDGUEPjnVldVRSAwrlfCueUDNX7MQg7g';
  var carro = null;
  function leerCarro() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carro = c; pintarTodo(); })
      .catch(function () {});
  }
  function enviarEntrega() {
    if (!window.fetch || !carro || !carro.token) return;
    var retiro = modo === 'retiro';
    var env = retiro ? 0 : montoDe(zona);
    var sub = Math.round((carro.total_price || 0) / 100);
    var cuerpo = {
      cart_token: carro.token,
      metodo: retiro ? 'Retiro presencial' : 'Envío a domicilio',
      zona: retiro ? PUNTO_RETIRO : zona,
      costo_envio: env,
      direccion: retiro ? '' : (datos.dir || ''),
      barrio: retiro ? '' : (datos.barrio || ''),
      referencia: retiro ? '' : (datos.ref || ''),
      subtotal: sub,
      total: sub + env,
      nota: carro.note || '',
      items: (carro.items || []).map(function (i) {
        return { titulo: i.product_title, variante: i.variant_title || '', cantidad: i.quantity, precio: Math.round(i.final_line_price / 100) };
      })
    };
    try {
      fetch(SUPA_URL, {
        method: 'POST',
        keepalive: true, /* sigue aunque la página pase a la de pago */
        headers: { 'content-type': 'application/json', apikey: SUPA_KEY, authorization: 'Bearer ' + SUPA_KEY },
        body: JSON.stringify(cuerpo)
      }).catch(function () {});
    } catch (err) {}
  }

  function pintar(raiz) {
    var retiro = modo === 'retiro';
    var sel = raiz.querySelector('[data-calc-select]');
    var filas = raiz.querySelector('[data-calc-resultado]');
    var env = retiro ? 0 : (zona ? montoDe(zona) : 0);
    var ok = retiro || env > 0;

    Array.prototype.forEach.call(raiz.querySelectorAll('[data-calc-modo]'), function (b) {
      b.setAttribute('aria-pressed', b.dataset.calcModo === modo ? 'true' : 'false');
    });
    raiz.querySelector('[data-calc-bloque-envio]').hidden = retiro;
    raiz.querySelector('[data-calc-bloque-retiro]').hidden = !retiro;
    var nota = raiz.querySelector('[data-calc-nota]');
    if (nota) nota.hidden = retiro;

    CAMPOS.forEach(function (k) {
      var c = raiz.querySelector('[data-calc-campo="' + k + '"]');
      if (!c) return;
      if (c !== document.activeElement) c.value = datos[k] || '';
      c.disabled = retiro; /* en retiro no viaja la dirección al pedido */
    });
    var pais = raiz.querySelector('[name="attributes[País de entrega]"]');
    if (pais) pais.disabled = retiro;

    espejo(raiz);
    var cc = raiz.querySelector('[data-calc-attr-carrito]');
    if (cc) cc.value = (carro && carro.token) || cc.value || '';
    sel.value = (!retiro && env) ? zona : '';
    raiz.querySelector('[data-calc-attr-metodo]').value = retiro ? 'Retiro presencial' : 'Envío a domicilio';
    raiz.querySelector('[data-calc-attr-zona]').value = retiro ? PUNTO_RETIRO : (env ? zona : '');
    raiz.querySelector('[data-calc-attr-costo]').value = ok ? gs(env) : '';
    if (!ok) { filas.hidden = true; return; }

    var subtotal = Math.round((parseInt(raiz.dataset.precioBase, 10) || 0) / 100);
    raiz.querySelector('[data-calc-etiqueta]').textContent = retiro ? 'Retiro presencial' : 'Envío a ' + zona;
    raiz.querySelector('[data-calc-costo]').textContent = gs(env);
    totalTxt = gs(subtotal + env);
    raiz.querySelector('[data-calc-total]').textContent = totalTxt;
    filas.hidden = false;
    raiz.classList.remove('calc-envio--falta');
    raiz.querySelector('[data-calc-error]').hidden = true;
  }
  /* Copia los datos al formulario de pago de Shopify para que llegue la dirección ya cargada. */
  function espejo(raiz) {
    var retiro = modo === 'retiro';
    var v = {
      country: 'Paraguay',
      address1: (datos.dir || '').trim(),
      address2: [(datos.barrio || '').trim(), (datos.ref || '').trim()].filter(Boolean).join(' · '),
      city: montoDe(zona) ? zona.replace(/ \(solo centro\)/, '') : ''
    };
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-calc-co]'), function (i) {
      i.value = v[i.dataset.calcCo] || '';
      i.disabled = retiro || !i.value;
    });
  }
  function botones() {
    Array.prototype.forEach.call(document.querySelectorAll('button[name="checkout"]'), function (b) {
      if (!b.dataset.textoOriginal) b.dataset.textoOriginal = b.textContent.trim();
      var hay = hayZona() && !!b.form && !!b.form.querySelector('[data-calc-envio]');
      b.textContent = hay ? b.dataset.textoOriginal + ' · ' + totalTxt : b.dataset.textoOriginal;
    });
  }
  function pintarTodo() { Array.prototype.forEach.call(raices(), pintar); botones(); }

  function iniciar(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';
    var sel = raiz.querySelector('[data-calc-select]');
    var nombres = [];
    TARIFAS.forEach(function (t) { nombres = nombres.concat(t.zonas); });
    nombres.sort(function (a, b) { return a.localeCompare(b, 'es'); });
    nombres.forEach(function (z) {
      var o = document.createElement('option');
      o.value = z;
      o.textContent = z; /* sin precio: el costo se ve recién en el cálculo final */
      sel.appendChild(o);
    });
    pintar(raiz);
    botones();
  }
  function escanear() { Array.prototype.forEach.call(raices(), iniciar); }

  /* Al elegir en cualquiera (página o mini-carrito) se sincronizan todos. */
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches || !e.target.matches('[data-calc-select]')) return;
    zona = e.target.value;
    try { localStorage.setItem(LLAVE, zona); } catch (err) {}
    pintarTodo();
  });

  /* Envío a domicilio / retiro presencial. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-calc-modo]') : null;
    if (!b) return;
    modo = b.dataset.calcModo === 'retiro' ? 'retiro' : 'envio';
    try { localStorage.setItem(LLAVE + '-modo', modo); } catch (err) {}
    pintarTodo();
  });

  /* Los datos de entrega se guardan y se copian a la otra vista (página / mini-carrito). */
  document.addEventListener('input', function (e) {
    var c = e.target && e.target.matches && e.target.matches('[data-calc-campo]') ? e.target : null;
    if (!c) return;
    datos[c.dataset.calcCampo] = c.value;
    try { localStorage.setItem(LLAVE + '-datos', JSON.stringify(datos)); } catch (err) {}
    if (c.dataset.calcCampo === 'dir' && c.value.trim()) {
      c.classList.remove('calc-envio--falta');
      var er = c.closest('.calc-envio').querySelector('[data-calc-error-dir]');
      if (er) er.hidden = true;
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-calc-campo="' + c.dataset.calcCampo + '"]'), function (o) { if (o !== c) o.value = c.value; });
    Array.prototype.forEach.call(raices(), espejo);
  });

  /* Campo obligatorio: sin ciudad y dirección (o retiro presencial) no se puede ir a pagar. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var boton = e.submitter;
    if (!f || !f.querySelector || (boton && boton.name !== 'checkout')) return;
    var raiz = f.querySelector('[data-calc-envio]');
    if (!raiz) return;
    if (modo === 'retiro') { enviarEntrega(); return; }
    var dir = raiz.querySelector('[data-calc-campo="dir"]');
    var faltaZona = !montoDe(zona);
    var faltaDir = !dir || !dir.value.trim();
    if (!faltaZona && !faltaDir) { enviarEntrega(); return; }
    e.preventDefault();
    e.stopPropagation();
    var sel = raiz.querySelector('[data-calc-select]');
    raiz.classList.toggle('calc-envio--falta', faltaZona);
    raiz.querySelector('[data-calc-error]').hidden = !faltaZona;
    if (dir) { dir.classList.toggle('calc-envio--falta', faltaDir); raiz.querySelector('[data-calc-error-dir]').hidden = !faltaDir; }
    var destino = faltaZona ? sel : dir;
    if (destino.scrollIntoView) destino.scrollIntoView({ block: 'center', behavior: 'smooth' });
    destino.focus();
  }, true);

  /* Si cambia el carrito (cantidades, quitar), se recalcula con el total nuevo. */
  document.addEventListener('silver:carrito', function (e) {
    var c = e.detail;
    if (c && typeof c.total_price === 'number') {
      Array.prototype.forEach.call(raices(), function (r) { r.dataset.precioBase = c.total_price; });
      carro = c;
      pintarTodo();
    }
  });

  /* El mini-carrito se vuelve a dibujar al cambiar: se inicializan los campos nuevos. */
  if (window.MutationObserver) {
    new MutationObserver(escanear).observe(document.body, { childList: true, subtree: true });
  }

  window.__scEnvio = { escanear: escanear };
  leerCarro();
  escanear();
})();
